import { brandsOpenApi } from '@constants';
import { axiosBoa } from '@utils';
import { getParent, types } from 'mobx-state-tree';
import { createStoreAction } from './utils';

export const GoogleAdsStore = types
    .model('GoogleAdsStore', {
        pending: types.maybeNull(types.boolean),
        negativeKeywords: types.maybeNull(types.array(types.string)),
        enabledByBrand: types.maybeNull(types.boolean)
    })
    .views((self) => ({
        get root() {
            return getParent(self);
        },
        get negativeKeywordsString() {
            return self.negativeKeywords.length ? self.negativeKeywords.join(',') : '';
        }
    }))
    .actions((self) => {
        const action = createStoreAction(self);

        return {
            getData: action(
                function* get() {
                    self.pending = true;
                    const response = yield axiosBoa.get(brandsOpenApi.googleAds.get);
                    self.enabledByBrand = response?.enabledByBrand;
                    self.negativeKeywords = response?.negativeKeywords?.keywords || [];
                },
                {
                    onFinally: () => (self.pending = false)
                }
            ),
            updateData: action(
                function* update({ googleAdsEnabledByBrand, googleAdsNegativeKeywords }) {
                    self.pending = true;

                    yield axiosBoa.post(brandsOpenApi.googleAds.update, {
                        enabledByBrand: googleAdsEnabledByBrand,
                        negativeKeywords: googleAdsNegativeKeywords
                    });
                    yield self.getData();
                },
                {
                    onFinally: () => (self.pending = false)
                }
            )
        };
    });
